import { http } from './api.service'

const DOMAIN_LIST_CACHE_DURATION = 5 * 60 * 1000

const cacheByEndpoint = new Map()
const pendingRequestByEndpoint = new Map()
let activeAuthenticationScope = null

function synchronizeAuthenticationScope () {
  const token = typeof window === 'undefined'
    ? ''
    : window.localStorage.getItem(`${process.env.VUE_APP_APPLICATION}-token`) || ''

  if (activeAuthenticationScope === token) {
    return
  }

  activeAuthenticationScope = token
  cacheByEndpoint.clear()
  pendingRequestByEndpoint.clear()
}

export function fetchDomainList (endpoint = '/domain', { force = false } = {}) {
  synchronizeAuthenticationScope()
  const cacheEntry = cacheByEndpoint.get(endpoint)
  if (!force && cacheEntry && Date.now() < cacheEntry.expiresAt) {
    return Promise.resolve([...cacheEntry.domains])
  }

  if (!force && pendingRequestByEndpoint.has(endpoint)) {
    return pendingRequestByEndpoint.get(endpoint).then(domains => [...domains])
  }

  let request = null
  request = http.get(endpoint)
    .then(({ data }) => {
      const domains = Array.isArray(data) ? data : []
      if (pendingRequestByEndpoint.get(endpoint) === request) {
        cacheByEndpoint.set(endpoint, {
          domains,
          expiresAt: Date.now() + DOMAIN_LIST_CACHE_DURATION
        })
      }
      return domains
    })
    .finally(() => {
      if (pendingRequestByEndpoint.get(endpoint) === request) {
        pendingRequestByEndpoint.delete(endpoint)
      }
    })

  pendingRequestByEndpoint.set(endpoint, request)
  return request.then(domains => [...domains])
}
